import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: '0 0 0 0',
  },
  season: {
    '&:focus': {
      outline: 'none',
    },
  },
  optionContainer: {
    height: '116px',
    // margin: '30px 0 30px 0',
    paddingBottom: '26px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      height: 'auto',
      paddingBottom: '35px',
      flexWrap: 'wrap',
    },
  },
  selectOption: {
    height: '36px',
    paddingLeft: '15px',
    paddingRight: '15px',
    marginLeft: '12px',
    // margin: '0 0 0 5px',
  },
  viewOption: {},
  emptyDataContainer: {
    textAlign: 'center',
  },
  resultCount: {
    margin: 0,
    fontSize: '16px',
    fontWeight: 'bold',
    [theme.breakpoints.down('md')]: {
      marginTop: '35px',
      marginBottom: '20px',
      fontSize: '14px',
    },
  },
  searchOptionContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    height: '36px',
    fontSize: '14px',
    '& > *': {
      margin: '0 0 0 12px',
    },
    [theme.breakpoints.down('md')]: {
      height: '32px',
      '& > *': {
        margin: '0 0 0 4px',
      },
    },
  },
  paginationContainer: {
    marginBottom: '110px',
  },
}));

export default useStyles;
